import { gql } from "apollo-boost";

const SYNC_WOO_COMMERCE_PRODUCTS = gql`
  mutation {
    syncWooCommerceProducts {
      data
      status
      error
    }
  }
`;

export default SYNC_WOO_COMMERCE_PRODUCTS;
